export interface JugadorPosicionJSON {
    jp_id: string | null;
    jp_descripcion: string;
    jp_activo: boolean;
}

export class JugadorPosicion {
    protected constructor(
    private id: string | null,
    private descripcion: string,
    private activo: boolean) {}

    static createFrom( id: string | null,
    descripcion: string,
    activo: boolean) {
        return new this( id,
        descripcion,
        activo)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: JugadorPosicion) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: JugadorPosicionJSON) {
        return JugadorPosicion.createFrom( entity.jp_id,
        entity.jp_descripcion,
        entity.jp_activo)
    }

    toJSON(): JugadorPosicionJSON {
        return {
            jp_id: this.getId(),
            jp_descripcion: this.getDescripcion(),
            jp_activo: this.getActivo()
        }

    }

    getId(): string | null { return this.id; }

    getDescripcion(): string { return this.descripcion; }

    getActivo(): boolean { return this.activo; }

    setId(value: string | null):void { this.id = value; }

    setDescripcion(value: string):void { this.descripcion = value; }

    setActivo(value: boolean):void { this.activo = value; }

}

